import { FileOpener } from '@capacitor-community/file-opener';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';

export const downloadWeb = (fileName: string, fileType: 'pdf' | 'csv' | 'zip', blob: Blob | MediaSource) => {
  const hiddenElement = document.createElement('a');
  const url = window?.URL || window?.webkitURL;
  const blobString = url.createObjectURL(blob);
  hiddenElement.style.display = 'none';
  hiddenElement.href = blobString;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${fileName}.${fileType}`;
  hiddenElement.click();
};

export const downloadInApp = async (fileName: string, fileType: 'pdf' | 'csv' | 'zip', result: any) => {
  const mimeContentType = fileType === 'pdf' ? 'application/pdf' : 'text/csv';
  // If content is Blob, convert it to Text
  let convertBlob;
  if (result instanceof Blob) {
    convertBlob = await result.text();
  }

  await Filesystem.writeFile({
    path: `${fileName}.${fileType}`,
    data: convertBlob ? convertBlob : result.data,
    directory: Directory.Documents,
    encoding: Encoding.UTF8
  });

  const getUriResult = await Filesystem.getUri({
    directory: Directory.Documents,
    path: `${fileName}.${fileType}`
  });

  await FileOpener.open({
    filePath: getUriResult.uri,
    contentType: mimeContentType,
    openWithDefault: true
  });
};
